export const formSubmit = {
  link: 'https://formsubmit.co/ajax/e32713b6f08f8bdbb6c22560b3de6b62',
};
